import { ScoreboardEntry } from "~App";
import { Engine } from "./Engine";
import { LocalInterface } from "./LocalInterface";
import { L, log, logLevel } from "./log";
import { Background } from "./Background";

export class Game {
  engine?: Engine;
  pusher: (text: string, colour?: string) => void;
  disconnectHandler: () => void;
  setScoreboard: React.Dispatch<React.SetStateAction<ScoreboardEntry[]>>;
  private ctx: CanvasRenderingContext2D;

  constructor(
    canvas: Element,
    pusher: (text: string, colour?: string) => void,
    disconnectHandler: () => void,
    setScoreboard: React.Dispatch<React.SetStateAction<ScoreboardEntry[]>>
  ) {
    this.pusher = pusher;
    this.disconnectHandler = disconnectHandler;
    this.setScoreboard = setScoreboard;
    this.ctx = (canvas as HTMLCanvasElement).getContext("2d")!;
    this.ctx.font = "20px sans-serif";
  }

  init = logLevel(
    L.INFO,
    async (code: string, playerName: string, playerColour: string) => {
      if (!code) {
        const resp = await fetch("new", {
          method: "POST",
        });
        if (resp.status === 200) {
          code = await resp.text();
        } else {
          throw new Error("Failed to create new room");
        }
      }
      this.engine = new Engine(
        code,
        this.pusher,
        this.disconnectHandler,
        this.setScoreboard,
        playerName,
        playerColour
      );
      log(L.DEBUG, "Done initializing game");
    }
  );

  onTick = logLevel(L.INFO, async () => {
    if (!this.engine?.remote.ready) {
      this.ctx.fillStyle = "#000000";
      this.ctx.fillRect(0, 0, Background.WIDTH, Background.HEIGHT + 120);
      this.ctx.fillStyle = "#FFFFFF";
      this.ctx.fillText("not connected", 10, 30);
      return;
    }
    if (this.engine!.tick < this.engine!.remote.tick()) {
      await this.engine!.onTick();
      this.ctx.drawImage(this.engine!.renderer.canvas, 0, 0);
    }
  });
}
